<template>
    <!-- TODO: Do anything special for application forms? -->
    <div v-if="hasApplicationForm || isOutLink" class="btn-div">
        <nuxt-link
            v-if="hasApplicationForm"
            :to="applicationFormUrl"
            class="btn"
            :class="[
                'btn-' + background,
                'btn-' + size
            ]"
        >
            {{ ctaText }}
            <i v-if="icon" :class="icon" />
        </nuxt-link>
        
        <a
            v-else-if="isOutLink"
            :href="outLinkUrl"
            target="_blank"
            class="btn"
            :class="[
                'btn-' + background,
                'btn-' + size
            ]"
        >
            {{ ctaText }}
            <i v-if="icon" :class="icon" />
        </a>
        <span v-if="$isNorway()" class="compliance">Annonselenke</span>
    </div>
</template>
<script>
export default {
    props: {
        background: {
            type: String,
            default: '',
            required: false
        },
        size: {
            type: String,
            default: '',
            required: false
        },
        icon: {
            type: String,
            default: undefined,
            required: false,
        },
        link: {
            type: Object,
            required: true
        },
        text: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        ctaText() {
            
            if (this.text !== null) {
                return this.text;
            }

            return this.$translate('cta_apply', 'Ansök nu');
        },
        hasApplicationForm() {

            if (this.link.type === 'lender') {
                // lenders can't have applications form
                return false;
            }

            return !this.isOutLink;
        },

        applicationFormUrl() {
            return this.$prismic.linkResolver(
                this.link,
                false, 
                'application'
            );
        },
        isOutLink() {

            if (this.link.type === 'lender') {
                return Boolean(this.link.data.out_link_url);
            }

            return this.link.data.application_type === 'out_link';
        },
        outLinkUrl() {

            let link = `/out/${this.link.id}/`;
            if (this.link.uid === 'tf-bank-mastercard') {
                // The old TF Bank redirect page has been blacklisted by Google,
                // so therefor I'm hardcoding the use of a another url.
                // https://swegamingab.slack.com/archives/C046B8L1EKB/p1783914848513559

                link = `/out/tf-bank-mastercard-redirect/`;
            }

            const tracking = this.$store.state.brokerTracking;
            if (tracking && Object.keys(tracking).length > 0) {

                // if there are broker tracking set, i.e. we got tracking from 
                // an application or auction, we should just add all that to the outlink
                // and then let the redirector handle the rest
                return link += '?' + (new URLSearchParams(tracking)).toString();
            }

            return link;
        },
    }
};
</script>
<style lang="scss" scoped>
    .card-sticky-mobile::v-deep {
        .compliance {
            background-color: $white;
        }
    }
    .compliance {
        display: block;
        text-align: center;
        padding: 8px 0;
        font-size: .8em;
        color: $muted;
        font-weight: lighter;
    }
</style>
